window.app = window.app || {};
window.app.cw = window.app.cw || {};
window.app.cw.common = window.app.cw.common || {};

app.cw.common.LoadingSpinner = {
    spinner: '<div><p class="text-center p-4 m-0"><span><img src="/v5/images/loading_spinner.svg" width="32" height="32" alt="Loading"/></span></p></div>',
    show: function showLoadingSpinner(message) {
        if (!message) {
            message = '';
        }

        // bootstrap modal markup in _LayoutBase.cshtml
        var $el = $('#cw_ajax_common_loading_spinner');
        const $modal = new bootstrap.Modal($el, {
            backdrop: 'static',
            keyboard: false
        });

        if (!$el.length) {
            return false;
        }
        else if ($el.hasClass('show')) {
            // modal already initialized
            // prevent multiple backdrops if the loading modal is already showing
            if ($('.modal-backdrop').length > 1 && $el.hasClass('show'))
                $('.modal-backdrop').first().remove();
        }

        $(window).on('keydown', function (e) {
            try {
                var key = e.which || e.keyCode || e.charCode;
                if (key === 27) {
                    e.preventDefault();
                    return false;
                }
            }
            catch (err) { };
        });

        var $msgEl = $el.find('#cw_ajax_common_loading_spinner_msg_wrap');
        var $msg = $('#cw_ajax_common_loading_spinner_msg');
        if ($msg.length) {
            $msg.text(message);
        }
        else {
            $msgEl.append('<span id="cw_ajax_common_loading_spinner_msg">' + message + '</span>');
        }

        $modal.show();
    },
    hide: function hideLoadingSpinner() {
        const $el = document.querySelector('#cw_ajax_common_loading_spinner');
        const $modal = bootstrap.Modal.getOrCreateInstance($el);
        $modal.hide();
        // workaround for backdrop not being removed
        // https://stackoverflow.com/questions/69424157/bootstrap-5-hide-modal-does-not-remove-backdrop
        $('.modal-backdrop').hide();
    }
};